export const CALL_DURATION_TICK_MS = 1000;
